const PATTERNS = [
    '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
    '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
    '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
    '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
    '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
    '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
    '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
    '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
    '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
    '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
    '114131', '311141', '411131', '211412', '211214', '211232', '2331112'
];

const START_B = 104;
const QUIET_ZONE = '0000000000';

/**
 * @param {string} pattern
 * @returns {string}
 */
function modules(pattern) {
    let bits = '';
    for (let index = 0; index < pattern.length; index += 1) {
        const width = parseInt(pattern[index], 10);
        const bar = index % 2 === 0 ? '1' : '0';
        for (let step = 0; step < width; step += 1) {
            bits += bar;
        }
    }
    return bits;
}

/**
 * Code 128, subconjunto B. Un 1 es barra negra.
 *
 * @param {string} text
 * @returns {string}
 */
function encodeCode128(text) {
    const values = [START_B];
    const source = String(text);
    for (let index = 0; index < source.length; index += 1) {
        const code = source.charCodeAt(index);
        if (code < 32 || code > 126) {
            values.push(0);
            continue;
        }
        values.push(code - 32);
    }

    let checksum = values[0];
    for (let index = 1; index < values.length; index += 1) {
        checksum += values[index] * index;
    }
    values.push(checksum % 103);

    let bits = QUIET_ZONE;
    for (let index = 0; index < values.length; index += 1) {
        bits += modules(PATTERNS[values[index]]);
    }
    bits += modules(PATTERNS[106]);
    return bits + QUIET_ZONE;
}

export { encodeCode128 };
